import React from 'react'
import { Helmet } from 'react-helmet-async'
import { SecuritySettingsLayout } from '../../layouts/Settings'

const SecuritySettingsPage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Security Settings</title>
      <meta name="description" content="Security Settings page" />
    </Helmet>
    <SecuritySettingsLayout />
  </React.Fragment>
)

export default SecuritySettingsPage
